import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import { Button } from "@/components/ui/button";
import { Languages, KeyRound, Mail, QrCode } from "lucide-react";
import Logo from "@/components/Logo";

export default function Landing() {
    const { t, lang, setLang } = useApp();
    return (
        <div className="min-h-screen coffee-bg flex flex-col">
            <header className="flex items-center justify-between p-5 md:p-8">
                <Logo size={52} />
                <Button variant="ghost" size="sm" onClick={() => setLang(lang === "ar" ? "en" : "ar")} className="gap-2" data-testid="landing-lang-toggle">
                    <Languages className="h-4 w-4" />{t("switch_lang")}
                </Button>
            </header>

            <section className="flex-1 flex flex-col items-center justify-center p-6 md:p-12 text-center">
                <h1 className={`${lang === "ar" ? "font-ar" : "font-display-en italic"} text-5xl md:text-7xl lg:text-8xl tracking-tight leading-none mb-4 gold-text`}>
                    {t("app_name")}
                </h1>
                <p className="text-base md:text-lg text-muted-foreground max-w-md mb-12">{t("tagline")}</p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full max-w-3xl">
                    <Link to="/login" data-testid="landing-owner-login">
                        <div className="rounded-2xl border border-border bg-card/60 hover:border-primary/60 hover:bg-card transition-all p-6 grain h-full active:scale-95">
                            <Mail className="h-7 w-7 text-primary mb-3 mx-auto" />
                            <div className="font-medium">{t("owner_login")}</div>
                            <div className="text-xs text-muted-foreground mt-2">{t("email")} + {t("password")}</div>
                        </div>
                    </Link>
                    <Link to="/staff-login" data-testid="landing-staff-login">
                        <div className="rounded-2xl border border-border bg-card/60 hover:border-primary/60 hover:bg-card transition-all p-6 grain h-full active:scale-95">
                            <KeyRound className="h-7 w-7 text-primary mb-3 mx-auto" />
                            <div className="font-medium">{t("staff_login")}</div>
                            <div className="text-xs text-muted-foreground mt-2">{t("pin")} · 4 digits</div>
                        </div>
                    </Link>
                    <Link to="/menu" data-testid="landing-menu-link">
                        <div className="rounded-2xl border border-border bg-card/60 hover:border-primary/60 hover:bg-card transition-all p-6 grain h-full active:scale-95">
                            <QrCode className="h-7 w-7 text-primary mb-3 mx-auto" />
                            <div className="font-medium">{t("view_menu")}</div>
                            <div className="text-xs text-muted-foreground mt-2">{t("scan_to_browse")}</div>
                        </div>
                    </Link>
                </div>
            </section>

            <footer className="p-5 text-center text-xs text-muted-foreground">
                © {new Date().getFullYear()} · Café 24 · Khartoum, Sudan
            </footer>
        </div>
    );
}
